// @flow

import { numberToCurrency } from '../../../services/numberToCurrency'
import catalogMedia from './assets/catalog'

export default {
  productID: 'hardCoded.productID.inedit',
  title: 'hardCoded.title.inedit',
  slug: 'hardCoded.slug.inedit',
  catalog: {
    title: 'hardCoded.catalog.title.inedit',
    catalogMedia,
    price: numberToCurrency('8.22'),
    color: '#0e171c'
  }
}
